import React, { useState } from "react";
import { isEmpty, pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Button, Input, Toast } from "antd-mobile";
import useCustomTranslation from "@/hooks/useTranslation";

const InvitationCode: React.FC<{
	inviteCode: string;
	required: boolean;
	onVisiblePopup: (visible: boolean) => void;
	onSubmitCode?: (code: string) => void;
}> = ({ inviteCode, required, onVisiblePopup, onSubmitCode }) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const [value, setValue] = useState(inviteCode);

	const onSubmit = () => {
		if (!required && isEmpty(value)) {
			Toast.show({
				content: t("InputInvitationCode"),
				position: "top",
			});
			return;
		}
		onVisiblePopup(false);
		onSubmitCode?.(value);
	};

	return (
		<div className={classes.invitationCodeWrap}>
			<h2>{t("InputInvitationCode")}</h2>
			<div className="inputWrap">
				<Input
					placeholder={t("InvitationCode")}
					value={value}
					onChange={(val) => {
						setValue(val);
					}}
					disabled={!isEmpty(inviteCode)}
					style={{
						height: pxToRem(50),
						width: pxToRem(250),
						borderRadius: pxToRem(8),
						"--color": "#FFFFFF",
						"--text-align": "center",
						backgroundColor: "#181A22",
					}}
				/>
			</div>
			<Button
				onClick={onSubmit}
				block
				shape="rounded"
				style={{
					height: pxToRem(50),
					fontSize: pxToRem(16),
					fontWeight: "700",
					"--border-width": "0",
					"--text-color": "#FFFFFF",
					background:
						" linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
				}}
			>
				{t("Next")}
			</Button>
		</div>
	);
};

export default InvitationCode;

const useStyles = createUseStyles({
	invitationCodeWrap: {
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(38),
			top: pxToRem(20),
		},
		background: "linear-gradient(to bottom right, #181B24 0, #232C48 100%)",
		"& h2": {
			color: "#FFFBEE",
			fontSize: pxToRem(18),
			fontWeight: "500",
			lineHeight: pxToRem(28),
			textAlign: "center",
		},
		"& .inputWrap": {
			display: "flex",
			justifyContent: "center",
			padding: {
				top: pxToRem(15),
				bottom: pxToRem(18),
			},
		},
	},
});
